<template>
  <div class="form-group custom-control custom-checkbox"
    v-bind:class="{'has-error': errors.has(field.key)}">
    <small class="label" v-html="sanitizedFieldTitle"></small>
    <label class="form-item-group form-item-checkbox"
      v-for="option in field.options"
      v-bind:key="option.value">
        <input type="checkbox"
          class="custom-control-input"
          v-bind:name="field.key"
          v-bind:value="option.value"
          v-bind:checked="value.includes(option.value)"
          v-on:change="updateValue"
          v-validate="validationRules"
          v-bind:data-vv-as="strippedFieldTitle"
          tabindex="1">
        <span class="custom-control-label">
          {{ option.title }}
        </span>
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * CheckBoxes
 * -- Implements v-model
 *
 * A field that renders a group of checkboxes.
 */
export default {
  name: 'CheckBoxes',
  mixins: [
    InputMixin,
  ],
  props: {
    /**
     * The Array of input values
     */
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    /**
     * Updates the value array with the given event and emits the new value
     * to the parent component.
     * @param event {Event} the event raised by an input
     */
    updateValue(event) {
      const index = this.value.indexOf(event.target.value);
      const newValue = this.value.slice();
      if (index > -1 && !event.target.checked) {
        // This value is already in the list, we need to remove it.
        newValue.splice(index, 1);
      } else if (index === -1 && event.target.checked) {
        // We should add this value to the list
        newValue.push(event.target.value);
      }
      this.$emit('input', newValue);
    },
  },
};
</script>
